<script setup lang="ts">
import { CONFIDENCE_LABELS_ET, type Grounding } from "@maimu/contracts";
import { computed } from "vue";

const props = defineProps<{ grounding: Grounding }>();

/** Verbatim Phase-1 labels: Kindel vaste / Võimalik vaste / Vajab inimese vastust. */
const label = computed(() => CONFIDENCE_LABELS_ET[props.grounding.confidence]);

const source = computed(() => {
  switch (props.grounding.kind) {
    case "tools":
      return "elavad andmed";
    case "knowledge":
      return "teadmus";
    default:
      return "kontrollimata";
  }
});
</script>

<template>
  <span class="chip" :class="grounding.confidence" :title="grounding.note ?? undefined">
    {{ label }}
    <span class="source">· {{ source }}</span>
  </span>
</template>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 0.15rem 0.65rem;
  border: 1px solid;
}

.source {
  font-weight: 400;
  opacity: 0.8;
}

.high {
  color: var(--green-dark);
  background: #e7f1ef;
  border-color: #bcd8d3;
}

.medium {
  color: var(--gold-dark);
  background: var(--soft);
  border-color: var(--gold);
}

.low {
  color: var(--warn);
  background: #f8ebea;
  border-color: #e0bcbb;
}
</style>
